if (!customElements.get('declock-cart-upsell')) {
  customElements.define(
    'declock-cart-upsell',
    class DeclockCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.addEventListener('click', this.handleClick.bind(this));
        this.querySelectorAll('[data-declock-upsell-track]').forEach((track) => {
          let animationFrame;
          track.addEventListener(
            'scroll',
            () => {
              window.cancelAnimationFrame(animationFrame);
              animationFrame = window.requestAnimationFrame(() => this.updateTrackControls(track));
            },
            { passive: true },
          );
          this.updateTrackControls(track);
        });
      }

      handleClick(event) {
        const arrow = event.target.closest('[data-declock-upsell-arrow]');
        if (arrow && this.contains(arrow)) {
          this.moveTrack(arrow);
          return;
        }

        const addButton = event.target.closest('[data-declock-cart-upsell-add]');
        if (addButton && this.contains(addButton)) this.addProduct(addButton);
      }

      moveTrack(button) {
        const row = button.closest('.declock-cart-upsell__row');
        const track = row?.querySelector('[data-declock-upsell-track]');
        const card = track?.querySelector('[data-declock-cart-upsell-card]');
        if (!track || !card) return;

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const direction = button.dataset.declockUpsellArrow === 'previous' ? -1 : 1;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      updateTrackControls(track) {
        const row = track.closest('.declock-cart-upsell__row');
        const previous = row?.querySelector('[data-declock-upsell-arrow="previous"]');
        const next = row?.querySelector('[data-declock-upsell-arrow="next"]');
        const remaining = track.scrollWidth - track.clientWidth - track.scrollLeft;

        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = remaining <= 2;
      }

      async addProduct(button) {
        if (button.disabled || button.classList.contains('is-loading')) return;
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const status = this.querySelector('[data-declock-upsell-status]');
        button.disabled = true;
        button.classList.add('is-loading');
        if (status) status.textContent = '';

        try {
          const body = new FormData();
          body.append('id', variantId);
          body.append('quantity', '1');

          const cartDrawer = document.querySelector('cart-drawer');
          if (this.dataset.context === 'drawer' && cartDrawer?.getSectionsToRender) {
            body.append(
              'sections',
              cartDrawer
                .getSectionsToRender()
                .map((section) => section.id)
                .join(','),
            );
            body.append('sections_url', window.location.pathname);
            cartDrawer.setActiveElement?.(button);
          }

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body,
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add this product.');
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'declock-cart-upsell',
              productVariantId: variantId,
              cartData: result,
            });
          }

          if (this.dataset.context === 'drawer' && cartDrawer && result.sections) {
            cartDrawer.renderContents(result);
          } else {
            window.location.reload();
          }
        } catch (error) {
          button.disabled = false;
          button.classList.remove('is-loading');
          if (status) status.textContent = error.message;
          console.error(error);
        }
      }
    },
  );
}
